export const INSTALLATION_TYPES = {
  CLOUD: 'cloud',
  COMMUNITY: 'community',
};
